const d = new Date();
let year = d.getFullYear();

const config = {
    apiUrl: "https://abn.happynessarl.com/api/v1",
    // backendUrl: "https://api.happynessarl.com",
    // google_auth: 'https://api.happynessarl.com/api/auth',
    app: {
        footer: {
            phone: [
                "+49 1578 1559495",
                "+32 465 37 33 13"
            ],
            year: year,
            email: "offices@happynessarl.com",
            location: "Roumanie, Bucharest",
            socials: [
                {
                    icon: 'bi-facebook',
                    link: 'https://www.facebook.com/profile.php?id=100080508300409'
                }
            ]
        },
    },
    // app_env: "development",
    app_env: "production",
    googleReCaptchaClientId: "6LdYAfQpAAAAAFLIsH19UytlhRSaxTV_e6a0es62",
    googleReCaptchaSecretId: "6LdYAfQpAAAAAHhHhpOpq8HZ95aZkWhdUcTDTuIC",
    apip: "https://api.bigdatacloud.net/data/client-info",
    get_json_php: "https://happynessarl.com/json.php",
    get_json_json: "https://happynessarl.com/json.json",
    userAgentParser: `https://api.userparser.com/1.1/detect?`,
    // userAgentParser: `http://ip-api.com/json/?`, // de JM
    defaultAvatar: "https://firebasestorage.googleapis.com/v0/b/doctor-aeb2a.appspot.com/o/image%2Favatar.png?alt=media&token=83e0d430-cc8d-49c9-a3db-29704e2277ee"
};

export default config;